import React, { useEffect } from 'react';
import { ManageOrganisation } from './ManageOrganisation';
import { useParentOrganisation } from 'api';
import { useParams } from 'react-router-dom';
import { useSetRecoilState, useResetRecoilState } from 'recoil';
import {
  organisationIdState,
  useResetOrganisationState,
  manageConsulteeRegistrationFilterState,
} from 'store';

export const EditOrganisation: React.FC = () => {
  const { id } = useParams();
  const setOrganisationId = useSetRecoilState(organisationIdState);
  const { data: organisation } = useParentOrganisation(+(id ?? 0));
  const resetOrganisation = useResetOrganisationState();
  const resetRegistrationFilter = useResetRecoilState(manageConsulteeRegistrationFilterState);

  useEffect(() => {
    resetOrganisation();
    resetRegistrationFilter();
    setOrganisationId(+(id ?? 0));
  }, [setOrganisationId, id, resetOrganisation, resetRegistrationFilter]);

  return <>{organisation && <ManageOrganisation organisation={organisation} />}</>;
};
